module.exports = __webpack_public_path__ + "img/ETH.28ed3eb7.svg";